// @flow
import React, { Component, type Node } from 'react';
import { throttle } from 'lodash';
import classnames from 'classnames';
import Sticky from 'react-stickynode';

import { heights } from './Navigation.constants';

type State = {
  isHidden: boolean,
  isLocked: boolean,
  isSticky: boolean,
  lastY: number,
};

export function stickyNav(WrappedComponent: Node) {
  return class NavigationSticky extends Component<*, State> {
    constructor(props: *) {
      super(props);

      this.state = {
        isHidden: false,
        isLocked: false,
        isSticky: false,
        lastY: 0,
      };
    }

    componentDidMount() {
      document.addEventListener('scroll', this.handleScroll, false);
      this.handleScroll();
    }

    componentWillUnmount() {
      document.removeEventListener('scroll', this.handleScroll, false);
    }

    onLock = (isLocked: boolean = false) => {
      this.setState({ isLocked });
    };

    handleScroll = throttle(() => {
      const { lastY, isLocked } = this.state;

      if (!isLocked) {
        const posY = Math.max(window.pageYOffset, 0);

        const stickyStart = heights.NAVIGATION_NARROW_HEIGHT;
        const scrolledDown = posY > lastY;

        this.setState(() => ({
          isHidden: scrolledDown && posY > stickyStart,
          lastY: posY,
        }));
      }
    }, 200);

    onStateChange = (status: { status: string }) => {
      this.setState(() => ({ isSticky: status.status !== Sticky.STATUS_ORIGINAL }));
    };

    render() {
      const { isHidden, isLocked, isSticky } = this.state;

      return (
        <Sticky
          enableTransforms={false}
          innerClass={classnames('w-full', {
            '-translate-y-100': isSticky && isHidden,
          })}
          innerZ={isLocked ? 7 : 5}
          onStateChange={this.onStateChange}
        >
          <WrappedComponent {...this.props} onLock={this.onLock} isSticky={isSticky} />
        </Sticky>
      );
    }
  };
}
